<template>
  <v-app>
    <v-app-bar
      app
      fixed
      color="white"
      class="toolbar-not-padding elevation-1"
    >
      <v-toolbar-items>
        <v-btn
          text
          light
          to="/"
        >
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-divider vertical></v-divider>
      </v-toolbar-items>
      <v-toolbar-title>
        <v-icon
          style="padding-right: 15px; padding-left: 15px"
        >
          settings
        </v-icon>
        <span>{{ $t('profile.title') }}</span>
      </v-toolbar-title>
    </v-app-bar>
    <v-content>
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-container v-else class="mt-5">
        <v-row>
          <v-col cols="3">
            <v-list rounded class="pa-0" color="transparent">
              <v-list-item
                v-for="(option, i) in options"
                :key="i"
                :to="option.to"
              >
                <v-list-item-action>
                  <v-icon>{{ option.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ option.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
          <v-col cols="9">
            <!-- <transition name="fade"> -->
              <router-view></router-view>
            <!-- </transition> -->
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <DrawerEditProfile/>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex'
import DrawerEditProfile from '@/components/Account/editProfileDrawer'

export default {
  components: {
    DrawerEditProfile
  },
  data () {
    return {
      isLoading: false,
      options: [
        {
          icon: 'people',
          text: this.$t('profile.options.personal_info'),
          disabled: false,
          to: '/account/profile'
        },
        {
          icon: 'lock',
          text: this.$t('profile.options.password'),
          disabled: false,
          to: '/account/password'
        }
      ]
    }
  },
  async created () {
    // this.isLoading = true
    // await this.getProfile()
    // this.isLoading = false
  },
  methods: {
    ...mapActions({
      getProfile: 'auth/getProfile'
    })
  }
}
</script>

<style scoped>
.toolbar-not-padding .v-toolbar__content {
  padding: 0;
}

.active-menus {
  color: #8c8282 !important;
}
.v-list-item--active {
  color: #8c8282 !important;
  font-weight: bolder !important;
}
.active-menus > * {
  color: #8c8282 !important;
}
.active-menus:hover {
  color: #595252 !important;
  border: 1px solid #eeeeee;
  background-color: #cbc8c8;
}
</style>
